var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{class:{ 'text-required': _vm.required }},[_vm._v(_vm._s(_vm.label))]),_c('b-form-datepicker',{attrs:{"id":'datepicker-dateformat1 ' + _vm.id,"date-format-options":{
      year: 'numeric',
      month: 'numeric',
      day: '2-digit',
    },"locale":"br"},on:{"input":_vm.onChange},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }